import { render, staticRenderFns } from "./CardTaskItem.vue?vue&type=template&id=38af9811&scoped=true"
import script from "./CardTaskItem.vue?vue&type=script&lang=js"
export * from "./CardTaskItem.vue?vue&type=script&lang=js"
import style0 from "./CardTaskItem.vue?vue&type=style&index=0&id=38af9811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af9811",
  null
  
)

export default component.exports